import { useEffect, useState } from 'react'
import debounce from 'lodash-es/debounce'

const useWidth = (ref?: React.MutableRefObject<HTMLDivElement>): number | null => {
  const [browserWidth, setBrowserWidth] = useState<number | null>(null)
  const [componentWidth, setComponentWidth] = useState<number | null>(null)

  useEffect(() => {
    const updateWidth = debounce(
      () => {
        setBrowserWidth(window.innerWidth)
      },
      100,
      {
        leading: false,
        trailing: true
      }
    )

    window.addEventListener('resize', updateWidth)
    updateWidth()

    return () => {
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  useEffect(() => {
    if (ref && ref.current && browserWidth) {
      setComponentWidth(ref.current.getBoundingClientRect().width)
    }
  }, [browserWidth, ref])

  if (ref) {
    return componentWidth
  }

  return browserWidth
}

export default useWidth
